<template>
  <div class="mentions-wrapper">
    <div class="gold-plaque">
      Hens saved this website Aug 29, 2025
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.mentions-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  font-size: 0.9rem;
}

.gold-plaque {
  background: linear-gradient(135deg, #FFD700, #FFF8DC);
  color: #3d2b1f;
  padding: 0.75rem 1.25rem;
  border: 2px solid #daa520;
  border-radius: 16px;
  clip-path: polygon(
    10% 0%, 90% 0%, 100% 10%,
    100% 90%, 90% 100%, 10% 100%,
    0% 90%, 0% 10%
  );
  box-shadow: inset 0 0 8px #fff8, 0 0 8px #0002;
  font-weight: bold;
  text-align: center;
  max-width: 90vw;
  line-height: 1.4;
}
</style>
